/** @format */

import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import './addSubject.scss'
import { useAddSubjectMutation } from '../../app/services/subjectApi'

const AddSubject: React.FC = () => {
  const { t: _ } = useTranslation();
  const [showModal, setShowModal] = useState<boolean>(false);

  const [addSubjectMutation] = useAddSubjectMutation();

  const [id, setId] = useState<string>("")
  const [enTitle, setEnTitle] = useState<string>("");
  const [cyTitle, setCyTitle] = useState<string>("");

  const addSubject = async (id: string, enTitle: string, cyTitle: string) => {
    await addSubjectMutation({
      id: id,
      title: {
        en: enTitle,
        cy: cyTitle,
      },
      indexed: false,
    })
  }

  return (
    <>
      <Button variant="outline-editing" className="w-50" onClick={() => setShowModal(true)}>
      {_("addSubject.heading")}</Button>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        aria-label="add-subject-modal"
        centered
      >
        <Modal.Header>
          {_("addSubject.heading")}
        </Modal.Header>
        <Modal.Body>
          <Form
            className="add-subject-form"
          >
            <Form.Group>
              <h5>
                <span style={{ color: "red" }}>*</span>
                &nbsp;
                {_("addSubject.id")}
              </h5>
              <Form.Control 
                name="id"
                className="mb-2"
                role="input"
                aria-label=
                {_("addSubject.id")}
                required
                value={id}
                onChange={(e) => setId(e.target.value)}
              />
            </Form.Group>

            <Form.Group>
              <h5 className="mt-4">
                <span style={{ color: "red" }}>*</span>
                  &nbsp;
                  {_("addSubject.titleEn")}
              </h5>
              <Form.Control 
                name="title-en"
                className="mb-2"
                role="input"
                aria-label=
                {_("addSubject.titleEn")}
                required
                value={enTitle}
                onChange={(e) => setEnTitle(e.target.value)}
              />
            </Form.Group>

            <Form.Group>
              <h5 className="mt-4">
                <span style={{ color: "red" }}>*</span>
                  &nbsp;
                  {_("addSubject.titleCy")}
              </h5>
              <Form.Control 
                name="title-cy"
                className="mb-2"
                role="input"
                aria-label=
                {_("addSubject.titleCy")}
                required
                value={cyTitle}
                onChange={(e) => setCyTitle(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex gap-3 justify-content-end">
            <Button
              role="button"
              variant="outline-editing"
              onClick={() => setShowModal(false)}
            >
              {_("addSubject.cancel")}
            </Button>
            <Button
              disabled={false} //isloading
              role="button"
              variant="danger"
              onClick={async () => {
                // ADD SUBJECT
                await addSubject(id, enTitle, cyTitle)
                setShowModal(false);
              }}
            >
                {_("addSubject.add")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddSubject;
